module.exports = __webpack_public_path__ + "static/img/careleb970a2b.png";